import {
  GET_LIST_FILTER,
  LOADING_GET_LIST_FILTER,
  GET_LIST_TOTAL_PIPELINES,
  LOADING_GET_LIST_TOTAL_PIPELINES,
  GET_LIST_RM,
  LOADING_GET_LIST_RM,
  INFINITE_SCROLL_LIST_RM,
  LOADING_INFINITE_SCROLL_LIST_RM,
  GET_DETAIL_RM,
  LOADING_GET_DETAIL_RM,
} from '../constants/merchant';

const initialState = {
  listFilter: [],
  isLoadingListFilter: false,
  listTotalPipeline: [],
  isLoadingListTotalPipeline: false,
  listRM: { data: [] },
  isLoadingListRM: false,
  isLoadingInfiniteScrollListRM: false,
  DetailRM: [],
  isLoadingDetailRM: false,
};

export default function reducer(
  state = initialState,
  action = { type: '', payload: [] }
) {
  const { type, payload } = action;

  switch (type) {
    case GET_LIST_FILTER:
      return {
        ...state,
        listFilter: payload,
        isLoadingListFilter: false,
      };
    case LOADING_GET_LIST_FILTER:
      return {
        ...state,
        isLoadingListFilter: true,
      };
    case GET_LIST_TOTAL_PIPELINES:
      return {
        ...state,
        listTotalPipeline: payload,
        isLoadingListTotalPipeline: false,
      };
    case LOADING_GET_LIST_TOTAL_PIPELINES:
      return {
        ...state,
        isLoadingListTotalPipeline: true,
      };
    case GET_LIST_RM:
      return {
        ...state,
        listRM: payload,
        isLoadingListRM: false,
      };
    case LOADING_GET_LIST_RM:
      return {
        ...state,
        isLoadingListRM: true,
      };
    case INFINITE_SCROLL_LIST_RM:
      return {
        ...state,
        listRM: { ...state.listRM, data: [...state.listRM.data, ...payload] },
        isLoadingInfiniteScrollListRM: false,
      };
    case LOADING_INFINITE_SCROLL_LIST_RM:
      return {
        ...state,
        isLoadingInfiniteScrollListRM: true,
      };
    case GET_DETAIL_RM:
      return {
        ...state,
        DetailRM: payload,
        isLoadingDetailRM: false,
      };
    case LOADING_GET_DETAIL_RM:
      return {
        ...state,
        isLoadingDetailRM: true,
      };
    default:
      return state;
  }
}
